module.exports = __webpack_public_path__ + "c622bb2c3151f9b9b774ee2c312c8150.jpg";